import {getDownloadURL, ref, uploadBytes} from "firebase/storage";
import {storage} from "../config/firebase";

export const uploadImage = async ({img, url}) => {
  if (!img || typeof img !== "object") {
    return img || null;
  }
  const fileFolderRef = ref(storage, url);
  const imgRef = await uploadBytes(fileFolderRef, img);
  return await getDownloadURL(imgRef.ref);
}